//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  /******************************************
  ** 组件名称
  * @description 组件描述
  * @author zhangwei
  *****************************************
  prop1          <type>            <属性描述>
  *****************************************/
  name: "downloadApp",
  components: {},
  props: {
  },
  data() {
    return {
      headerIsShow: true,
      linkCode:'',
      keyName:'',
      keyValue:null,
      showButten:null
    };
  },
  computed: {},
  watch:{
   $route:{
      deep:true,
      handler(newV,oldV){
       if(newV.name=='LoginPage'||newV.name=='LoginPhone'||newV.name=='CourseTypeDetailPage'||newV.name=='VlogDetail'||newV.name=='activityPage'||newV.name=='CircleContent'||newV.name=='CircleDetail'||newV.name=='ArticleDetailPage'||newV.name=='CourseDetailPage'||newV.name=='personalHomePage'||newV.name=='seriesDetail'||newV.name=='votePage'){
         this.headerIsShow=false
         this.keyName='';
       }else{
         this.headerIsShow=true
         this.keyName='home';
       }
       this.$nextTick(()=>{
         //一键直达 魔链初始化
         this.switchInint()
       })
       
      }
    },
  },

  mounted(){},
methods: {
      switchInint(){
        this.keyName='home';
        new JMLink({
          jmlink:'https://bm41l8.jgmlink.cn/AAI3',// 短链地址
          button:document.querySelector('a#btnOpenApp07'),
          autoLaunchApp : false,
          downloadWhenUniversalLinkFailed: false,
          inapp:false,
          params: {
          'home':1
          }
        });
      },
    //关闭header
    closeHead() {
      this.headerIsShow = false;
      this.$emit('closeMargin')
     localStorage.setItem("closeMargin", "true");
     this.$store.dispatch('isShowAppDown')
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/downloadApp.vue